module.exports = __webpack_public_path__ + "static/media/bg_upload_CV.db8fe5b9.png";